import { render, staticRenderFns } from "./orderGroupDefine.vue?vue&type=template&id=577cf8b6&scoped=true&"
import script from "./orderGroupDefine.vue?vue&type=script&lang=js&"
export * from "./orderGroupDefine.vue?vue&type=script&lang=js&"
import style0 from "./orderGroupDefine.vue?vue&type=style&index=0&id=577cf8b6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "577cf8b6",
  null
  
)

export default component.exports